export const enum NotificationPosition {
  TOP = 'top',
  /** deprecated */
  MODAL = 'modal',
  /** deprecated */
  TAB = 'tab',
  FORM = 'form',
  DRAWER = 'drawer',
}

export const enum NotificationCardType {
  LOADING = 'loading',
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
}
